// src/hooks/useMotionSafe.ts
// Hook שמתחבר לAccessibilityWidget הקיים שלכם

import { useState, useEffect } from 'react';

export const useMotionSafe = () => {
  const [shouldReduceMotion, setShouldReduceMotion] = useState(false);

  useEffect(() => {
    // פונקציה לבדיקה אם צריך להפחית אנימציות
    const checkMotionPreference = () => {
      // בדיקה אם האפשרות של ה-AccessibilityWidget פעילה
      const hasNoAnimationsClass = document.body.classList.contains('accessibility-no-animations');

      // בדיקה אם יש העדפת מערכת
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const shouldReduce = hasNoAnimationsClass || prefersReducedMotion;
      setShouldReduceMotion(shouldReduce);
    };

    // בדיקה ראשונית
    checkMotionPreference();

    // האזנה לשינויים ב-body class (מה-AccessibilityWidget)
    const observer = new MutationObserver(() => {
      checkMotionPreference();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // האזנה לשינויים בהעדפות המערכת
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handleMediaChange = () => checkMotionPreference();

    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      observer.disconnect();
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);

  return {
    // האם אנימציות מותרות (הפוך מ-shouldReduceMotion)
    shouldAnimate: !shouldReduceMotion,

    // פונקציה שמחזירה מחלקת CSS רק אם אנימציות מותרות
    getAnimationClass: (animationClass: string) =>
      shouldReduceMotion ? '' : animationClass,

    // פונקציה שמחזירה מחלקת hover רק אם אנימציות מותרות  
    getHoverClass: (hoverClass: string) =>
      shouldReduceMotion ? '' : hoverClass,

    // בדיקה ישירה אם צריך להפחית אנימציות
    shouldReduceMotion
  };
};